import { combineReducers } from 'redux'
import { IntlReducer as Intl } from 'react-redux-multilingual'

import auth from './auth/reducer'
import user from './user/reducer'
import photoEditor from './photoEditor/reducer'
import placeDetector from './placeDetector/reducer'
import tools from './tools/reducer'
import plan from './plan/reducer'
import payment from './payment/reducer'

export default combineReducers({
    tools,
    auth,
    user,
    photoEditor,
    placeDetector,
    plan,
    payment,
    Intl,
})
